import type { ReactNode } from "react";
import { Icono } from "../../components/Icono";
import { Tarjeta } from "../../components/Tarjeta";

// Acordeón cerrado por defecto (spec §8/§1-4): agrupa las herramientas de
// planificación (Buscador de ventana libre, Calendario) para que dejen de
// competir visualmente con la Cola de Trabajo, sin perder funcionalidad —
// sólo se ocultan detrás de un toggle explícito, controlado por el padre
// (persistido en la URL vía useEstadoEnUrl, igual que el resto de "Mi
// Trabajo", para sobrevivir a un "volver").
export function PlanificacionColapsada({
  abierto,
  onCambiar,
  children,
}: {
  abierto: boolean;
  onCambiar: (abierto: boolean) => void;
  children: ReactNode;
}) {
  return (
    <Tarjeta tamano="normal" className="mb-8">
      <button
        type="button"
        onClick={() => onCambiar(!abierto)}
        aria-expanded={abierto}
        className="flex w-full items-center justify-between gap-2 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2"
      >
        <span className="flex items-center gap-2.5">
          <Icono nombre="agenda" className="h-5 w-5 text-texto-secundario" />
          <span className="text-base font-semibold text-texto">Planificación</span>
        </span>
        <Icono nombre="expandir-colapsar" className={`h-4 w-4 text-texto-secundario transition-transform ${abierto ? "rotate-180" : ""}`} />
      </button>
      {abierto && <div className="mt-5 space-y-6 border-t border-borde pt-5">{children}</div>}
    </Tarjeta>
  );
}
